import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      userSelect: "none",

      "& svg": {
        cursor: "pointer",
      },
    },
    icons: {
      gap: theme.spacing(13),
      display: "flex",
    },
    dropdownIcon: {
      transition: "0.3s",
      transform: ({
        isExpanded,
      }: {
        isExpanded?: boolean;
        noPadding?: boolean;
      }) => `rotate(${!isExpanded ? "180deg" : 0})`,
    },
    content: {
      marginTop: theme.spacing(12),
      padding: ({ noPadding }: { noPadding?: boolean }) =>
        theme.spacing(noPadding ? 0 : 12),
      backgroundColor: theme.gray50,
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      gap: "32px",
    },
    row: {
      display: "flex",
      gap: theme.spacing(10),
      justifyContent: "space-between",
    },
    left: {
      color: theme.gray800,
      textWrap: "nowrap",
      fontWeight: 500,
    },
    right: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      gap: theme.spacing(6),
      color: theme.gray800,
      textAlign: "right",
      fontWeight: 400,
    },
    visibilityBox: {
      fontSize: 12,
      color: theme.primary800,
      height: "24px",
      padding: theme.spacing(0, 4),
      borderRadius: "4px",
      border: `1px solid ${theme.gray200}`,
      background: theme.white00,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    sectionTitleWrapper: {
      display: "flex",
      gap: theme.spacing(8),
    },

    gridContainer: {
      alignItems: "start",
      fontWeight: 500,
      flexWrap: "nowrap",
      gap: theme.spacing(12),
    },
    gridChild: {
      background: "#FEFFFF",
      border: `1px solid ${theme.gray200}`,
      borderRadius: 8,
      boxShadow: "0px 1px 1px rgba(154, 147, 147, 0.25)",
      display: "flex",
      flexDirection: "column",
    },
    ruleHeader: {
      background: theme.gray50,
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(6, 8),
      gap: theme.spacing(2),
    },
    firstRule: {
      borderRadius: "8px 8px 0 0",
    },
    ruleTitle: {
      color: theme.gray800,
      fontSize: 14,
      fontWeight: 500,
    },
    ruleDesc: {
      color: theme.primary800,
      fontSize: 12,
      fontWeight: 400,
    },
    ruleContent: {
      boxShadow: `0px -1px 0px ${theme.gray100}`,
      padding: theme.spacing(8, 12),
    },
    conditionsHeader: {
      color: theme.gray800,
      fontWeight: 500,
    },
    readOnlyContainer: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4),
    },
    readOnlyWrapper: {
      display: "flex",
      alignItems: "center",
      marginTop: theme.spacing(8),
    },
    advancedSettings: {
      margin: 0,
      maxWidth: "846px",
    },
    vectorMargin: {
      margin: theme.spacing(-7, 0, 0, 2),
    },
    rule: {
      display: "flex",
      flexDirection: "column",
    },
    summaryError: {
      color: theme.red500,
    },
  }),
);
